module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// C:/Users/TechTeam/Desktop/deploy/sims-web-prod/src/app/auth/auth-component.html
// module id = ../../../../../src/app/auth/auth-component.html
// module chunks = main